module.exports = __webpack_public_path__ + "img/landlord-tenant-picture.7ade03f3.svg";